import React from 'react'

import { convertUTCtoMSK } from '../../../../../../../utils'
import { Table } from '../../../../../../../components/Table'
import { TableHead } from '../../../../../../../components/Table/TableHead'
import { TableBody } from '../../../../../../../components/Table/TableBody'

import { DisputeRecord } from '../../../../../matching/routes/Disputes/core/response.types'
import {
  DISPUTE_STATUS_BADGE,
  DISPUTE_STATUS_LABEL,
} from '../../../../../matching/routes/Disputes/core/consts'
import {
  renderAmount,
  renderAutoSituation,
  renderComment,
  renderCreatedBy,
  renderCulprits,
  renderDisputeType,
  renderResolvedBy,
} from '../../../../../matching/routes/Disputes/core/render'

interface Props {
  items: DisputeRecord[]
  loading?: boolean
  error?: boolean
}

/**
 * Read-only история диспутов клиента: колонки те же, что в журнале мэтчинга, кроме «Мерчант»
 * (у карточки клиента мерчант один и уже известен) и «Действия» — заводят диспут в очереди
 * мэтчинга, закрывают в журнале /matching/disputes.
 */
const ClientDisputesTable: React.FC<Props> = ({ items, loading, error }) => {
  if (loading) {
    return <div className='text-muted'>Загрузка…</div>
  }
  if (error) {
    return <div className='text-danger'>Не удалось загрузить диспуты</div>
  }
  if (!items.length) {
    return <div className='text-muted'>Диспутов не найдено</div>
  }

  return (
    <Table>
      <TableHead>
        <tr>
          <th>Токен тикета</th>
          <th>Тип</th>
          <th>Начало диспута</th>
          <th>Сумма</th>
          <th>Причина</th>
          <th>Ситуация</th>
          <th>Статус диспута</th>
          <th>Статус тикета</th>
          <th className='min-w-120px'>Виновник</th>
          <th>Кто открыл</th>
          <th>Кто закрыл</th>
          <th>Комментарий</th>
        </tr>
      </TableHead>
      <TableBody>
        {items.map((d) => (
          <tr key={d.id}>
            <td className='text-monospace'>{d.token}</td>
            <td className='text-nowrap'>{renderDisputeType(d)}</td>
            <td>{convertUTCtoMSK(d.startedAt)}</td>
            <td>{renderAmount(d)}</td>
            <td>{d.reason.title}</td>
            <td className='text-muted'>{renderAutoSituation(d)}</td>
            <td>
              <span className={`badge ${DISPUTE_STATUS_BADGE[d.status] ?? 'badge-light'}`}>
                {DISPUTE_STATUS_LABEL[d.status] ?? d.status}
              </span>
            </td>
            <td>
              <span className='badge badge-light'>{d.ticketStatus}</span>
            </td>
            <td>{renderCulprits(d)}</td>
            <td className={`text-muted ${d.createdBy ? 'text-monospace' : ''}`}>
              {renderCreatedBy(d)}
            </td>
            <td className={`text-muted ${d.resolvedBy ? 'text-monospace' : ''}`}>
              {renderResolvedBy(d)}
            </td>
            <td className='text-muted'>{renderComment(d.comment)}</td>
          </tr>
        ))}
      </TableBody>
    </Table>
  )
}

export default ClientDisputesTable
